module.exports = __webpack_public_path__ + "static/media/accessory13.078ca69a.webp";